import React, { useState } from 'react';
import classnames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import style from './SidebarItem.module.scss';

const SidebarItem = ({
  isSidebarOpen,
  isMobile,
  toggleSidebar,
  icon,
  name,
  path,
}) => {
  const [toggleOpen, setToggleOpen] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const isActive = location.pathname === path;

  const handleClose = () => setToggleOpen(false);
  const handleOpen = () => setToggleOpen(true);
  const onClickParent = () => {
    if (path) {
      isMobile && toggleSidebar();
      return history.push(path);
    }
  };

  return (
    <div>
      <Tooltip
        open={!isSidebarOpen && toggleOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        title={name}
        arrow
        placement="right"
      >
        <button
          className={classnames(style.container, { [style.active]: isActive })}
          onClick={onClickParent}
        >
          <div className={style.icon}>
            <i className={icon} />
          </div>
          <div className={style.text}>{name}</div>
        </button>
      </Tooltip>
    </div>
  );
};

export default SidebarItem;
